<template>
  <div>
    <div>
      <v-form>
        <v-card rounded="xl" flat class="pa-4 mb-4">
          <v-card-title>Reporte Z</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <label>Fecha inicial</label>
                <div style="border-bottom: 1px solid; margin-bottom: -1px">
                  <Datepicker :input-class="'v-input__control theme--light v-text-field dateinputClass '"
                    @input="getAperturas()" @selected="selectDate" :value="input_date.format('MM/DD/YYYY')">
                  </Datepicker>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>Fecha inicial</label>
                <div style="border-bottom: 1px solid; margin-bottom: -1px">
                  <Datepicker :input-class="'v-input__control theme--light v-text-field dateinputClass '"
                    @input="getAperturas()" @selected="selectDateFinal" :disabled-dates="disableDates"
                    :value="input_date_final.format('MM/DD/YYYY')"></Datepicker>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete label="Departamentos" v-model="selectDep" item-text="Nombre" item-value="id"
                  :items="departamentos" @input="getAperturas()"></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete label="Caja" v-model="selectCaja" item-value="id" item-text="Nomb" :items="cajasList"
                  @input="getAperturas()"></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete label="Turno" v-model="selectTurno" item-value="Turno" item-text="Desc"
                  :items="turnosList">
                  <template v-slot:append-outer>
                    <v-btn @click="getAperturas()" small color="primary">Buscar turnos</v-btn>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col md="12" cols="12">
                <v-select v-model="metodosPagoSelected" :items="getPDVPagosTipos" item-value="id" item-text="Nombre"
                  label="Metodos de pago" multiple></v-select>
              </v-col>
              <v-col cols="12" md="12">
                <v-btn block :loading="loadingpdf" color="green" class="mt-4" dark @click="generatePdf()">
                  Generar reporte
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </div>
  </div>
</template>

<script>
import "../../assets/css/sideBar.css";
import Datepicker from "vuejs-datepicker";
import Currency from "../../clases/Currencies.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import Modificadores from "../../clases/Modificadores.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteZ from "../../clases/PdfMakers/ReporteZ.js";
import ReporteZBOKKA from "../../clases/PdfMakers/ReporteZBOKKA.js";
import { forEach } from "lodash";
import { queryPorTurnos } from "../../clases/FirestoreTurnos.js";

export default {
  name: "ReporteTransacciones",
  components: {
    Datepicker,
  },
  props: ["hideMenu"],
  data() {
    return {
      costos: {},
      contenedores: [],
      areas: [],
      metodosPagoSelected: [],
      Comensales: 0,
      loadingpdf: false,
      showDevs: true,
      selectTurno: "ALL",
      selectCaja: "",
      aperturas: [],
      cierresList: [],
      pagos: [],
      monedas: [],
      transaccion: "",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      selectedRes: "",
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      cajero: "ALL",
      data_cajas: [],
      showModal: false,
      formKey: 0,
      data_ventas: [],
      data_devoluciones: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      Categories: [],
      familias: [],
      selectDep: "ALL",
      cajeros: [{ id: "ALL", Nomb: "Todos" }],
      reservations: [],
      cantFilter: "",
      countsData: [],
      datos: {
        ventas: [],
        totalesArea: {},
        descuentos: [],
        promosBokka: {},
      },
      confPromosDias: {
        0: [{ tag: "[RPTG-CONCAUSA]", nombre: "Promo con causa" }, { tag: "*Promo Jueves", nombre: "Todo lo que puedas comer" }, { tag: "*PROMOBOT", nombre: "Promo Botellas 499" }],
        1: [{ tag: "[RPTG-CONCAUSA]", nombre: "Promo con causa" }, { tag: "*PROMOBOT", nombre: "Promo Botellas 499" }],
        2: [{ tag: "[RPTG-CONCAUSA]", nombre: "Promo con causa" }, { tag: "*TACOS2X1", nombre: "Tacos 2x1" }, { tag: "*PROMOBOT", nombre: "Promo Botellas 499" }],
        3: [{ tag: "[RPTG-CONCAUSA]", nombre: "Promo con causa" }, { tag: "*PROMOMIERCOLES", nombre: "Promo Miercoles" }, { tag: "*PROMOBOT", nombre: "Promo Botellas 499" }],
        4: [{ tag: "[RPTG-CONCAUSA]", nombre: "Promo con causa" }, { tag: "*Promo Jueves", nombre: "Todo lo que puedas comer" }, { tag: "*PROMOBOT", nombre: "Promo Botellas 499" }],
        6: [{ tag: "[RPTG-CONCAUSA]", nombre: "Promo con causa" }, { tag: "*TEQUILA2X1", nombre: "Tequila 2x1" }, { tag: "*PROMOBOT", nombre: "Promo Botellas 499" }]
      }
    };
  },
  computed: {
    ...mapGetters(["getFirebaseApp"]),
    ...mapGetters(["getClientes", "getPDVPagosTipos", "getPDVMonedasLista"]),
    ...mapGetters(["getProductos"]),
    global_prod() {
      let productos = [];
      this.getProductos.forEach((element) => {
        if (
          element.Tipo != "AYB-Insumo" &&
          element.Tipo != "AYB-ICompuesto" &&
          !element.Dlat
        ) {
          productos.push(element);
        }
      });
      return productos;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    cajasList() {
      let dep = [
        {
          id: "ALL",
          Nomb: "Todos",
        },
      ];
      this.data_cajas.forEach((de) => {
        if (de.Dpto == this.selectDep) {
          dep.push(de);
        }
      });
      return dep;
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
          CajeroName: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    ventas_comp() {
      this.data_ventas.forEach((venta) => {
        if (venta.Cantidad == this.cantFilter) {
          venta.match = true;
        } else {
          venta.match = false;
        }
        for (const property in venta.Catalogo) {
          if (venta.Catalogo[property].Modificadores) {
            venta.Catalogo[property].ModificadoresList =
              Modificadores.parseToListOption(
                venta.Catalogo[property].Modificadores
              );
            let totalModi = 0;
            venta.Catalogo[property].ModificadoresList.forEach((modi) => {
              totalModi += modi.pco.C;
            });
            venta.Catalogo[property].totalModi = totalModi;
          }
        }
      });
      let data = this.data_ventas;
      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array;
    },
    devoluciones_comp() {
      let data = this.data_devoluciones;

      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array;
    },
    selectedReserva() {
      return this.selectedRes;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    comp_resumen_data() {
      let total_products = 0;
      let total_golf_round = 0;
      let total_proshop = 0;
      let total = 0;
      let total_pagos = 0;
      let totalCambio = 0;
      let total_pesos = 0;
      let total_dolar = 0;
      this.data_ventas.forEach((venta) => {
        let prod = Object.entries(venta.Catalogo);
        this.$pgsHelper.log(prod);
        prod.forEach((producto) => {
          if (producto[0] == "Golf_Round") {
            total_golf_round++;
          } else {
            total_proshop++;
          }
          total_products++;
        });

        total_pagos = total_pagos + venta.Cantidad;
        total = total + parseInt(venta.Total);
        totalCambio = totalCambio + (venta.Cambio ? venta.Cambio.MXN : 0);
        if (venta.moneda === Currency.getCurrencyDefault()) {
          total_pesos = total_pesos + venta.Cantidad;
        } else {
          total_dolar = total_dolar + venta.Cantidad;
        }
      });
      this.data_devoluciones.forEach((dev) => {
        //total_pagos = total_pagos + dev.Cantidad;
        //total = total + parseInt(dev.Total);
        //totalCambio = totalCambio + (dev.Cambio ? dev.Cambio.MXN : 0);
        if (dev.moneda === Currency.getCurrencyDefault()) {
          total_pesos = total_pesos - dev.Cantidad;
        } else {
          total_dolar = total_dolar - dev.Cantidad;
        }
      });
      return {
        total_pesos: total_pesos,
        total_dolar: total_dolar,
        total_productos: total_products,
        total_rounds: total_golf_round,
        total_proshop: total_proshop,
        total_metodo_pagos: Number(parseFloat(total_pagos).toFixed(2)),
        totalCambio: totalCambio,
        total: total,
      };
    },
    comp_clients() {
      let clientes = [];
      this.getClientes.forEach((cli) => {
        clientes.push({ id: cli.id, text: cli.Apellidos + " " + cli.Nombres });
      });
      return clientes;
    },
    comp_filter() {
      let filter = [];

      this.pagos.forEach((pago) => {
        this.monedas.forEach((moneda) => {
          filter.push(pago + "_" + moneda);
        });
      });
      return filter;
    },
    excel_data() {
      let dataExcel = [];
      this.data_ventas.forEach((venta) => {
        dataExcel.push({
          Folio: venta.Folio,
          Fecha: venta.FechaVenta,
          Hora: this.formatDate(venta.FechaCreacion),
          Cliente: venta.Cliente.Nombre,
          Cajero: this.$pgsHelper.getById(this.cajeros, "Id", venta.Cajero)
            .Nomb,
          Autorizacion: venta.IdTran,
          TipoPago: venta.TipoPago,
          TotalMetodoPago: this.$pgsHelper.formatNumber(venta.Cantidad),
          TotalVenta: this.$pgsHelper.formatNumber(venta.Total),
          Cambio: 0,
          Estatus: "Activo",
        });
      });
      this.data_devoluciones.forEach((venta) => {
        dataExcel.push({
          Folio: venta.Folio,
          Fecha: venta.Fecha,
          Hora: this.formatDate(venta.Crat),
          Cliente: venta.Cliente.Nombre,
          Cajero: this.$pgsHelper.getById(this.cajeros, "Id", venta.Cajero)
            .Nomb,
          Autorizacion: venta.IdTran,
          TipoPago: venta.TipoPago,
          TotalMetodoPago: this.$pgsHelper.formatNumber(venta.Cantidad),
          TotalVenta: this.$pgsHelper.formatNumber(venta.Cantidad),
          Cambio: 0,
          Estatus: "Devolucion",
        });
      });
      let data = dataExcel;
      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array;
    },
    possibleTags() {
      const grouped = {};

      this.global_prod.forEach(({ id, tags }) => {
        if (!tags?.length) return;
        if (!grouped[id]) grouped[id] = { prodId: id, tags: [] };
        grouped[id].tags.push(...tags);
      });

      return Object.values(grouped);
    },
  },

  methods: {
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getAperturas() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      if (this.selectCaja != "ALL" && this.selectCaja != "") {
        filter.push(firestore.where("Caja", "==", this.selectCaja));
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      //
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja);
        let cajeroData = this.$pgsHelper.getById(
          this.cajeros,
          "Id",
          apt.Cajero
        );
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = cajeroData.Nomb;
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || " +
          cajeroData.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    async getCostos() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_Costos", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where(
          "Dlat",
          "==",
          null
        ),
      ]);
      let costos = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      let globalCosto = {};
      costos.forEach((element) => {
        let prod = Object.entries(element.pds);
        prod.forEach((pd) => {
          if (!globalCosto[pd[0]]) {
            globalCosto[pd[0]] = [];
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          } else {
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          }
        });
      });
      this.costos = globalCosto;
    },
    async generatePdf() {
      this.loadingpdf = true;
      let tenant = this.$store.getters.getFirebaseApp.tenant;
      // las dos descargas son independientes: se lanzan en paralelo
      await Promise.all([this.getLoteCierres(), this.getVentas()]);
      this.loadingpdf = false;
      let zReport = new ReporteZ();
      if (tenant == "BOKA") {
        zReport = new ReporteZBOKKA();
      }

      let Cajero = (this.selectTurno == "ALL") ? "Todos" : "Sin cierre"
      let cierreData = this.$pgsHelper.getById(
        this.cierresList,
        "Turno",
        this.selectTurno
      )
      if (cierreData) {
        Cajero = cierreData.CajeroName
      }
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        Turno: this.selectTurno,
        DetailedData: (tenant == "BOKA") ? true : false,
        Tenant: tenant,
        TITLE:
          tenant == "PCUN"
            ? "CLUBS PUERTO CANCUN SA DE CV"
            : tenant == "BOKA"
              ? "BOKKA SMOKEHOUSE & GRILL"
              : "REPORTE Z",
        Departamento: this.selectDep,
        Comensales: this.Comensales,
        DeptoName: this.$pgsHelper.getById(
          this.departamentos,
          "id",
          this.selectDep
        ).Nombre,
        Cajero: Cajero,
        Caja: this.$pgsHelper.getById(this.cajasList, "id", this.selectCaja)
          ? this.$pgsHelper.getById(this.cajasList, "id", this.selectCaja).Nomb
          : "Todas",
      };
      let docData = zReport.getDocData(
        this.$pgsHelper.cloneObj(this.countsData),
        this.$pgsHelper.cloneObj(this.datos.ventas),
        this.getPDVPagosTipos,
        mainData,
        this.$pgsHelper.cloneObj(this.datos.descuentos),
        this.$pgsHelper.cloneObj(this.datos.totalesArea),
        this.$pgsHelper.cloneObj(this.datos.promosBokka)
      );
      pdfmake.createPdf(docData).open();
    },
    async getLoteCierres() {
      let turnos = [];
      if (this.selectTurno != "ALL") {
        turnos.push(this.selectTurno);
      } else {
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });
      }

      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("Tipo", "==", "Cierre"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      if (this.selectCaja != "ALL" && this.selectCaja != "") {
        filter.push(firestore.where("Caja", "==", this.selectCaja));
      }

      // una query por bloque de 30 turnos en vez de una por turno
      const cierres = await queryPorTurnos(
        firestore,
        "PDV_CierreApertura",
        turnos,
        filter
      );
      cierres.forEach((cierre) => {
        let cajeroData = this.$pgsHelper.getById(
          this.cajeros,
          "Id",
          cierre.Cajero
        );
        cierre.CajeroName = cajeroData.Nomb;
      });
      this.cierresList = cierres;
      this.countsData = this.countsProcess(cierres);
    },
    async getCierresDeprecated() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        /*firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),*/
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Cierre"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      if (this.selectCaja != "ALL" && this.selectCaja != "") {
        filter.push(firestore.where("Caja", "==", this.selectCaja));
      }
      if (this.selectTurno != "ALL") {
        filter.push(firestore.where("Turno", "==", this.selectTurno));
      } else {
        let turnos = [];
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });

        filter.push(firestore.where("Turno", "in", turnos));
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      //
      let cierres = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      /*cierres.forEach((element) => {
        element.CajeroNombre = this.$pgsHelper.getById(
          this.cashiers,
          "Id",
          element.Cajero
        ).Nomb;
      });*/
      let dataProcessed = this.countsProcess(cierres);
      this.countsData = dataProcessed;
      //this.data_cierres = cierres;
    },
    countsProcess(data) {
      let dataTotals = {};
      let dataTotalsSystem = {};
      let dataPropinas = {};
      data.forEach((cierre) => {
        if (this.selectTurno != "ALL") {
          if (cierre.Turno != this.selectTurno) {
            return false;
          }
        }
        //tratamiento de contadores del sistema
        let totals = Object.entries(cierre.Cnts.Ttl);
        totals.forEach((contador) => {
          let splitPago = contador[0].split("_");
          if (this.metodosPagoSelected.includes(splitPago[0])) {
            if (dataTotalsSystem[contador[0]]) {
              dataTotalsSystem[contador[0]] =
                dataTotalsSystem[contador[0]] + Number(contador[1]);
            } else {
              dataTotalsSystem[contador[0]] = Number(contador[1]);
            }
            if (splitPago[1] == "USD") {
              dataTotalsSystem[contador[0] + "_CONV"] =
                Currency.getExchangeRateByCurrency(
                  Number(dataTotalsSystem[contador[0]]),
                  "USD",
                  Currency.getCurrencyDefault(),
                  moment(cierre.Momento, "YYYY-MM-DD_HH:mm:ss").format(
                    "YYYY-MM-DD HH:mm"
                  )
                );
            }
          }

        });
        if (dataTotalsSystem["Cambio"]) {
          if (cierre?.Cnts?.Cmb) {
            dataTotalsSystem["Cambio"] =
              dataTotalsSystem["Cambio"] + Number(cierre?.Cnts?.Cmb?.MXN);
          }
        } else {
          if (cierre?.Cnts?.Cmb) {
            dataTotalsSystem["Cambio"] = Number(cierre?.Cnts?.Cmb?.MXN);
          }
        }

        //tratamiento de propinas
        if (cierre?.Cnts?.Pps) {
          let propinas = Object.entries(cierre.Cnts.Pps);
          propinas.forEach((contador) => {
            let splitPago = contador[0].split("_");
            if (this.metodosPagoSelected.includes(splitPago[0])) {
              if (dataPropinas[contador[0]]) {
                dataPropinas[contador[0]] =
                  dataPropinas[contador[0]] + Number(contador[1]);
              } else {
                dataPropinas[contador[0]] = Number(contador[1]);
              }
              if (splitPago[1] == "USD") {
                dataPropinas[contador[0] + "_CONV"] =
                  Currency.getExchangeRateByCurrency(
                    Number(dataPropinas[contador[0]]),
                    "USD",
                    Currency.getCurrencyDefault(),
                    moment(cierre.Momento, "YYYY-MM-DD_HH:mm:ss").format(
                      "YYYY-MM-DD HH:mm"
                    )
                  );
              }
            }

          });
        }

        //tratamiento de cantidades capturadas
        let totalsMonto = Object.entries(cierre.Montos);
        totalsMonto.forEach((monto) => {
          let splitPago = monto[0].split("_");
          if (this.metodosPagoSelected.includes(splitPago[0]) | splitPago[0] == "Tarjetas" | splitPago[0] == "TarjetasUSD") {
            if (dataTotals[monto[0]]) {
              dataTotals[monto[0]] =
                dataTotals[monto[0]] + Number(monto[1].Total);
            } else {
              dataTotals[monto[0]] = Number(monto[1].Total);
            }

            if (splitPago[1] == "USD") {
              dataTotals[monto[0] + "_CONV"] = Currency.getExchangeRateByCurrency(
                Number(dataTotals[monto[0]]),
                "USD",
                Currency.getCurrencyDefault(),
                moment(cierre.Momento, "YYYY-MM-DD_HH:mm:ss").format(
                  "YYYY-MM-DD HH:mm"
                )
              );
            }
          }

        });
      });

      if (dataTotalsSystem["Cambio"]) {
        dataTotalsSystem["EFVO_MXN"] =
          dataTotalsSystem["EFVO_MXN"] - dataTotalsSystem["Cambio"];
      }

      if (!dataPropinas["Tarjetas"]) {
        dataPropinas["Tarjetas"] =
          (dataPropinas["VISA_MXN"] ? dataPropinas["VISA_MXN"] : 0) +
          (dataPropinas["MACA_MXN"] ? dataPropinas["MACA_MXN"] : 0);
      }
      if (!dataPropinas["TarjetasUSD"]) {
        dataPropinas["TarjetasUSD"] =
          (dataPropinas["VISA_USD"] ? dataPropinas["VISA_USD"] : 0) +
          (dataPropinas["MACA_USD"] ? dataPropinas["MACA_USD"] : 0);

        dataPropinas["TarjetasUSD_CONV"] =
          (dataPropinas["VISA_USD_CONV"] ? dataPropinas["VISA_USD_CONV"] : 0) +
          (dataPropinas["MACA_USD_CONV"] ? dataPropinas["MACA_USD_CONV"] : 0);
      }

      if (!dataTotalsSystem["Tarjetas"]) {
        dataTotalsSystem["Tarjetas"] =
          (dataTotalsSystem["VISA_MXN"] ? dataTotalsSystem["VISA_MXN"] : 0) +
          (dataTotalsSystem["MACA_MXN"] ? dataTotalsSystem["MACA_MXN"] : 0);
      }

      if (!dataTotalsSystem["TarjetasUSD"]) {
        dataTotalsSystem["TarjetasUSD"] =
          (dataTotalsSystem["VISA_USD"] ? dataTotalsSystem["VISA_USD"] : 0) +
          (dataTotalsSystem["MACA_USD"] ? dataTotalsSystem["MACA_USD"] : 0);
        dataTotalsSystem["TarjetasUSD_CONV"] =
          (dataTotalsSystem["VISA_USD_CONV"]
            ? dataTotalsSystem["VISA_USD_CONV"]
            : 0) +
          (dataTotalsSystem["MACA_USD_CONV"]
            ? dataTotalsSystem["MACA_USD_CONV"]
            : 0);
        dataTotals["TarjetasUSD_CONV"] = dataTotalsSystem["TarjetasUSD_CONV"];
      }
      return {
        dataTotalsSystem: dataTotalsSystem,
        dataTotals: dataTotals,
        dataPropinas: dataPropinas,
      };
    },
    formatDate(timestamp) {
      let d = new Date(timestamp);
      //
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("HH:mm");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      let turnos = [];
      if (this.selectTurno != "ALL") {
        turnos.push(this.selectTurno);
      } else {
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });
      }
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      if (this.selectDep != "ALL") {
        filter.push(firestore.where("Departamento", "==", this.selectDep));
      }

      if (this.selectCaja != "ALL" && this.selectCaja != "") {
        filter.push(firestore.where("Caja", "==", this.selectCaja));
      }

      // una query por bloque de 30 turnos en vez de una por turno
      const listVentas = await queryPorTurnos(
        firestore,
        "PDV_Ventas",
        turnos,
        filter
      );

      this.datos.ventas = this.processVentas(listVentas);
      this.datos.totalesArea = this.processTotalesArea(listVentas);
      this.datos.promosBokka = await this.processPromosBokka(listVentas);
    },
    processVentas(datos) {
      this.Comensales = 0;
      let productosVenta = [];
      let descuentosGeneral = [];
      datos.forEach((el) => {
        this.Comensales += el.Comensales ? el.Comensales : 1;
        let pagos = Object.entries(el.Pagos);
        el.Catalogo.forEach((prod) => {
          prod.Descuentos.forEach((desc) => {
            if (this.$pgsHelper.getById(descuentosGeneral, "Desc", desc.Dsc)) {
              let exist = this.$pgsHelper.getById(
                descuentosGeneral,
                "Desc",
                desc.Dsc
              );
              if (exist) {
                descuentosGeneral[exist.idx].Cnt += Number(desc.Cnt);
                descuentosGeneral[exist.idx].Ttl += Number(desc.Ttl.C);
              }
            } else {
              descuentosGeneral.push({
                Desc: desc.Dsc,
                Cnt: desc.Cnt,
                Ttl: desc.Ttl.C,
              });
            }
          });

          if (prod.Id.includes("RVA-ExtraRidder")) {
            prod.Familia.I = "EXTRA RIDER";
            prod.Familia.N = "EXTRA RIDER";
            prod.Iva = 0;
          }
          if (prod.Id.includes("Reserva")) {
            if (prod.Orn != "Golf") {
              prod.Familia.I = prod.Orn;
              prod.Familia.N = prod.Orn;
            } else {
              prod.Familia.I = "GREEN FEE";
              prod.Familia.N = "GREEN FEE";
            }
          }
          if (prod.Tip == "ACT-Reserva") {
            let categoria = this.$pgsHelper.getById(
              this.Categories,
              "id",
              prod.Categoria.I
            );
            if (categoria) {
              let familiaData = this.$pgsHelper.getById(
                this.familias,
                "id",
                categoria.Familia
              );
              if (familiaData) {
                prod.Familia.I = categoria.Familia;
                prod.Familia.N = familiaData.Nombre;
              }
            }
          }

          if (prod.Id.includes("RVA-Transportacion")) {
            prod.Familia.I = "TRANSPORTACION";
            prod.Familia.N = "TRANSPORTACION";
            prod.Iva = 0;
          }
          if (prod.Tip == "Cupon") {
            prod.Familia.N = "Paquetes Rondas de Golf";
            prod.Familia.I = "Paquetes Rondas de Golf";
            prod.Iva = 0;
          }
          if (prod.Catalogo) {
            if (prod.Catalogo[0]) {
              let Catalogo = prod.Catalogo[0];
              if (Catalogo.Tip == "Serie") {
                prod.Familia.I = "GREEN FEE";
                prod.Familia.N = "GREEN FEE";
              }
            }
          }

          try {
            let pagos = Object.entries(prod.Pagos);
            if (pagos.length > 0) {
              Object.entries(prod.Pagos).forEach((pago) => {
                let metodoPago = pago[0].split("_")
                if (this.metodosPagoSelected.includes(metodoPago[0])) {
                  let noGrava = false;
                  if (
                    prod.Nombre.includes("Nueva Membresia") ||
                    prod.Nombre.includes("Cuota Extraordinaria")
                  ) {
                    noGrava = true;
                  }
                  let iva = prod.Iva / 100 + 1;
                  let imp = !noGrava
                    ? parseFloat(pago[1].def.C - pago[1].def.C / iva).toFixed(2)
                    : 0;
                  let st = !noGrava
                    ? parseFloat(pago[1].def.C - imp).toFixed(2)
                    : parseFloat(pago[1].def.C).toFixed(2);
                  let producto = {
                    /*Fecha: el.FechaVenta,
                  Folio: el.Folio,
                  Departamento: el.Departamento,*/
                    ClaveSAT: prod.Familia ? prod.Familia.C : "-",
                    Familia: prod.Familia ? prod.Familia.N : "-",
                    FamiliaId: prod.Familia.I,
                    Cantidad: pago[0] ? parseFloat(pago[1].cnt).toFixed(2) : "",
                    prod: prod,
                    iva: !noGrava ? prod.Iva : 0,
                    /*Categoria: prod.Categoria ? prod.Categoria.N : "-",
                  Producto: prod.Nombre,
                  Cantidad: pago[0] ? parseFloat(pago[1].cnt).toFixed(2) : "",
                  Monto: pago[1].rel.C,
                  Moneda: pago[1].rel.M,
                  TipoPago: pago[0] ? pago[1].name : "",*/
                    Descuento: pago[1].dsc
                      ? parseFloat(pago[1].dsc.C).toFixed(2)
                      : "-",
                    /* Autorizacion: pago[0] ? pago[1].code : "",*/
                    //Impuestos:((pago[1].def.C/100)*16),
                    Subtotal: st,
                    Impuestos: imp,
                  };
                  productosVenta.push(producto);

                }

              });
            } else {
              let producto = {
                /*Fecha: el.FechaVenta,
                Folio: el.Folio,
                Departamento: el.Departamento,*/
                ClaveSAT: prod.Familia ? prod.Familia.C : "-",
                Familia: prod.Familia ? prod.Familia.N : "-",
                FamiliaId: prod.Familia.I,
                Cantidad: prod.Cnt,
                prod: prod,
                iva: 0,
                /*Categoria: prod.Categoria ? prod.Categoria.N : "-",
                Producto: prod.Nombre,
                Cantidad: pago[0] ? parseFloat(pago[1].cnt).toFixed(2) : "",
                Monto: pago[1].rel.C,
                Moneda: pago[1].rel.M,
                TipoPago: pago[0] ? pago[1].name : "",*/
                /* Autorizacion: pago[0] ? pago[1].code : "",*/
                //Impuestos:((pago[1].def.C/100)*16),
                Subtotal: 0,
                Impuestos: 0,
              };
              productosVenta.push(producto);
            }
          } catch (e) {
            console.log(el.Folio);
          }
        });
      });

      this.datos.descuentos = descuentosGeneral;
      return this.groupByFamilia(productosVenta);
    },
    processTotalesArea(ventas) {
      let totalesArea = {}
      ventas.forEach(venta => {
        let mesa = null
        venta.Catalogo.forEach((producto) => {
          if (producto.ExtraParams?.AYB?.Mesa) {
            mesa = producto.ExtraParams?.AYB?.Mesa
          }
        })
        if (mesa) {
          let mesaData = this.$pgsHelper.getById(this.contenedores, "id", mesa)
          if (mesaData) {
            let area = this.$pgsHelper.getById(this.areas, "id", mesaData.Area)
            if (area) {
              if (!totalesArea[area.id]) {
                totalesArea[area.id] = {
                  Nombre: area.Nombre,
                  Total: 0,
                  Ventas: 0,
                  Comensales: 0,
                }
              }
              totalesArea[area.id].Total += venta.Total
              totalesArea[area.id].Comensales += venta.Comensales
              totalesArea[area.id].Ventas++
            }
          }
        } else {
          if (!totalesArea["VentaRapida"]) {
            totalesArea["VentaRapida"] = {
              Nombre: "Venta Rapida",
              Total: 0,
              Ventas: 0,
              Comensales: 0,
            }

          }
          totalesArea["VentaRapida"].Total += venta.Total
          totalesArea["VentaRapida"].Comensales += venta.Comensales
          totalesArea["VentaRapida"].Ventas++
        }
      })
      return totalesArea
    },
    groupByFamilia(productos) {
      let groupData = {};
      productos.forEach((prod) => {
        if (groupData[prod.FamiliaId]) {
          groupData[prod.FamiliaId].Cantidad =
            Number(groupData[prod.FamiliaId].Cantidad) + Number(prod.Cantidad);
          groupData[prod.FamiliaId].Subtotal =
            Number(groupData[prod.FamiliaId].Subtotal) + Number(prod.Subtotal);
          groupData[prod.FamiliaId].Impuestos =
            Number(groupData[prod.FamiliaId].Impuestos) +
            Number(prod.Impuestos);
        } else {
          groupData[prod.FamiliaId] = {
            Cantidad: Number(prod.Cantidad),
            Subtotal: Number(prod.Subtotal),
            Impuestos: Number(prod.Impuestos),
            Iva: Number(prod.iva),
            Nombre: prod.Familia,
          };
        }
      });

      return groupData;
    },
    async processPromosBokka(ventas) {
      let dataPromos = {}
      if (this.input_date.isSame(this.input_date_final, "day")) {
        const dayOfWeek = this.input_date.day();

        const promos = this.confPromosDias[dayOfWeek]
        if (promos) {
          promos.forEach(promo => {
            ventas.forEach(venta => {
              let isPromoSale = false
              let comensales = venta.Comensales ? venta.Comensales : 1
              venta.Catalogo.forEach(producto => {
                const tag = this.possibleTags.find(
                  (t) => t.prodId === producto.Id
                );
                if (tag) {
                  if (tag.tags.includes(promo.tag)) {
                    isPromoSale = true
                    if (!dataPromos[promo.tag]) {
                      dataPromos[promo.tag] = {
                        Nombre: promo.nombre,
                        Cantidad: 0,
                        Total: 0,
                        TotalCuenta: 0,
                        Cuentas: 0,
                        CantidadMod: 0,
                        totalModificadores: 0,
                        totalCostoModificadores: 0,
                        costo: 0,
                        totalProductos: 0,
                        Comensales: 0
                      }
                    }
                    let precio = 0;
                    if (producto.Pagos) {
                      Object.entries(producto.Pagos).forEach((pago) => {
                        precio += pago[1].def.C;
                      });
                    }
                    let cantidadModificadores = 0
                    let totalModificadores = 0
                    let totalCostoModificadores = 0
                    let cantidad = producto.Cnt - (producto.Dto ? producto.Dto : 0);
                    let costo = 0
                    if (producto.Modificadores) {
                      producto.Modificadores.forEach((mod) => {
                        mod.sel.forEach((selection) => {
                          console.log(selection.Cnt, cantidad, selection.pco, selection)
                          cantidadModificadores = selection.Cnt * cantidad;
                          totalModificadores = selection.pco.C * cantidadModificadores;
                          if (this.costos[selection?.ref?.id]) {
                            const costosDepto = this.costos[selection?.ref?.id].find(c => c.depto == venta.Departamento)
                            totalCostoModificadores += ((costosDepto ? costosDepto.cto.C : 0) * selection?.ref?.cnt) * cantidadModificadores
                          }

                        })
                      })
                    }


                    if (this.costos[producto.Id]) {
                      console.log(this.costos[producto.Id], venta.Departamento)
                      const costosDepto = this.costos[producto.Id].find(c => c.depto == venta.Departamento)
                      costo = costosDepto ? costosDepto.cto.C : 0
                    }
                    if (producto.Id != "YTApy4QIHoOVsa7i3yP5") {
                      dataPromos[promo.tag].Cantidad += cantidad
                    }

                    dataPromos[promo.tag].totalProductos += precio
                    dataPromos[promo.tag].CantidadMod += cantidadModificadores
                    dataPromos[promo.tag].totalModificadores += totalModificadores
                    dataPromos[promo.tag].Total += precio + totalModificadores
                    dataPromos[promo.tag].costo += costo * cantidad
                    dataPromos[promo.tag].totalCostoModificadores += totalCostoModificadores
                  }
                }
              })
              if (dataPromos[promo.tag] && isPromoSale) {
                dataPromos[promo.tag].Comensales += comensales
                dataPromos[promo.tag].TotalCuenta += venta.Total
                dataPromos[promo.tag].Cuentas++
              }
            })


          })

        }
        let tenant = this.$store.getters.getFirebaseApp.tenant;
        console.log("es tenant boka", tenant)
        if (tenant == "BOKA") {
          console.log("es tenant boka")
          if (dayOfWeek == 0) {
            console.log("es lunes")
            /*const juicySales = await this.getJuicySales(this.input_date.format("YYYY-MM-DD"))
            console.log(juicySales)
            if (juicySales) {
              dataPromos["*PROMOJUICY"] = {
                Nombre: "Hamburguesa con causa",
                Cantidad: Number(juicySales.data?.producto?.cnt),
                Total: Number(juicySales.data?.producto?.ttl.C) + Number(juicySales.data?.modificadores?.ttl.C),
                TotalCuenta: Number(juicySales.data?.cuentas?.ttl.C),
                Cuentas: Number(juicySales.data?.cuentas?.cnt),
                CantidadMod: Number(juicySales.data?.modificadores?.cnt),
                totalModificadores: Number(juicySales.data?.modificadores?.ttl.C),
                totalCostoModificadores: Number(juicySales.data?.modificadores?.ctt.C),
                costo: Number(juicySales.data?.producto?.ctt.C),
                totalProductos: Number(juicySales.data?.producto?.ttl.C),
                Comensales: Number(juicySales.data?.comensales?.cnt),
                isJuicy: true,
                Descuento: Number(juicySales.data?.descuento.C)
              }
            }*/
          }
        }
      }

      console.log(dataPromos)
      return dataPromos
    },

    async getJuicySales(date) {
      const response = await this.$store.getters.getFirebaseApp.fba
        .call("PDV-Reportes-reporteVentaDonacion",
          {
            "nombre": "Hamburguesa con causa",
            "departamento": "AYB-SmokeHouse",
            "fechas": {
              "inicio": date,
              "final": date
            },
            "destinatario": "[RESPUESTA]",
            "tag": "[RPTG-JUICY-LUCY]",
            "calculoadicional": "producto",
            "tenant": "BOKA"
          }
        )
      return (response.data) ? response.data : null

    },

    async getCajeros() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cajeros = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cajeros.push(toAdd);
          }
        });
      }
    },
    async getContenedores() {
      let mesas = [];
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Contenedores"
        );
      if (data.exists()) {
        const dataContenedores = Object.entries(data.val());
        dataContenedores.forEach((mapa) => {
          const contenedores = this.$pgsHelper.ArrayObjectToArray(mapa[1]);
          contenedores.forEach((mesa) => {
            mesas.push(mesa);
          });
        });
      }
      this.contenedores = mesas;
    },
    async getAreas() {
      let areasList = [];
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Areas"
        );
      if (data.exists()) {
        const dataAreas = Object.entries(data.val());
        dataAreas.forEach((mapa) => {
          const areas = this.$pgsHelper.ArrayObjectToArray(mapa[1]);
          areas.forEach((mesa) => {
            areasList.push(mesa);
          });
        });
      }
      this.areas = areasList;
    },
  },
  mounted() {
    this.getCajas();
    this.getCajeros();
    this.getCategories();
    this.getFamilias();
    this.getContenedores();
    this.getAreas();
    this.getCostos();
    this.getPDVPagosTipos.forEach((mp) => {
      this.metodosPagoSelected.push(mp.id)
    })
  },
  beforeCreate: function () { },
  beforeMount: function () {
    this.$emit("useNav", true);
  },
};
</script>

<style scoped>
.activeClass {
  background: #2185d075 !important;
}
</style>
